import { CATNAV_TOP_OF_PAGE_SPEED_EXPERIMENT_240523 } from "@faire/web-api/indigofair/settings/CATNAV_TOP_OF_PAGE_SPEED_EXPERIMENT_240523";

import { getSettingValueAndAssign } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingAndAssignCatNavTopOfPageSpeedExperiment = () =>
  getSettingValueAndAssign(CATNAV_TOP_OF_PAGE_SPEED_EXPERIMENT_240523, false);
